import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"full":""}},[(_vm.showResults)?_c('return-display',{attrs:{"article":_vm.ffDisplay}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }